// extracted by mini-css-extract-plugin
module.exports = {"list":"Scenarios_list__Oiz4m","item":"Scenarios_item__WcyK7","card":"Scenarios_card__s80Ge","button":"Scenarios_button__kYg7Z"};